// store.js
import { configureStore } from '@reduxjs/toolkit'; 
import userReducer from './slices/userSlice';  
import sidebarReducer from './slices/sidebarSlice';  
import formularioReducer from './slices/prospectSlice';
import darkModeSlice from "./slices/darkModeSlice"
import calendarReducer from "./slices/calendarSlice"
import podcastReducer from "./slices/podcastSlice"
import planReducer from "./slices/planSlice"
import eventoReducer from "./slices/eventosSlice"
import clientesReducer from "./slices/clientesSlice"
import coffeeReducer from "./slices/coffeSlice"


const store = configureStore({
  reducer: {
    user: userReducer,  
    sidebar: sidebarReducer,
    prospectos: formularioReducer,
    darkMode: darkModeSlice,
    calendar: calendarReducer,
    podcast: podcastReducer,
    plan: planReducer,
    evento: eventoReducer,
    clientes: clientesReducer,
    coffee: coffeeReducer
  },
});

export default store;  
